<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 't-heading',
    props: {
      tag: {
        type: String,
        default: 'h1',
        validator: v => ['h1', 'h2', 'h3', 'h4'].indexOf(v) !== -1
      },
      color: {
        type: String,
        default: 'inherit',
        validator: v =>
          [
            'black',
            'white',
            'concrete',
            'platinum',
            'silver',
            'gray',
            'granite',
            'black',
            'yellow',
            'blue',
            'green',
            'orange',
            'purple',
            'red',
            'inherit'
          ].indexOf(v) !== -1
      },
      branded: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['themeColorHEX']),
      headingClassList() {
        const classObj = {
          h1: ['text-28 leading-8'],
          h2: ['text-24 leading-7'],
          h3: ['text-20 leading-6'],
          h4: ['text-18 leading-5.5']
        }

        return [...classObj[this.tag], (!(this.branded && this.themeColorHEX) && `text-${this.color}`)]
      }
    },
    render(h) {
      const tag = this.tag
      const brandColor = this.branded && this.$helpers.getCorrectColor(this.themeColorHEX)

      return h(
        tag,
        {
          ref: this.ref,
          class: this.headingClassList,
          style: brandColor ? {color: brandColor} : {}
        },
        this.$slots.default
      )
    }
  }
</script>
